import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PATHS } from 'config';
import PageNotFound from 'feature/common/page-not-found';
import AppLayout from 'components/layout/app-layout';
import { PoiContextProvider } from 'feature/poi-module/use-poi';
import { ProviderRouter } from 'utils/provider-helper';
import { currentUrl } from 'utils/url-helper';

const ParkinglotsPage = lazy(() => import('feature/common/parkinglots'));
const PromotionPage = lazy(() => import('feature/common/promotion'));
const PromotionDetailPage = lazy(() => import('feature/common/promotion/detail'));
const PromotionGroupPage = lazy(() => import('feature/common/promotion/group'));

const CpcpayRouter = () => {
  return (
    <AppLayout>
      <Suspense fallback={''}>
        <Switch>
          <Route exact path={currentUrl('/')} component={<></>} />
          <ProviderRouter
            provider={PoiContextProvider}
            component={ParkinglotsPage}
            path={currentUrl(PATHS.PARKINGLOTS)}
          />
          <Route path={currentUrl(PATHS.PROMOTION)} component={PromotionPage} />
          <Route path={currentUrl(PATHS.PROMOTION_DETAIL)} component={PromotionDetailPage} />
          <Route path={currentUrl(PATHS.PROMOTION_GROUP)} component={PromotionGroupPage} />
          <Route path="*" component={PageNotFound} />
        </Switch>
      </Suspense>
    </AppLayout>
  );
};

export default CpcpayRouter;
